import { Injectable, inject } from '@angular/core';

import type { Metric } from 'web-vitals';

import { DatadogService } from './datadog.service';

/**
 * Core Web Vitals reporting, wired from an `APP_INITIALIZER`.
 *
 * Does nothing on the server or without a Datadog target: `web-vitals` reads
 * `PerformanceObserver` as its callbacks register, so it is loaded through a
 * dynamic `import()` behind the same browser guard the SDK boundary applies.
 */
@Injectable({
  providedIn: 'root'
})
export class PerformanceService {
  private readonly datadog = inject(DatadogService);
  private initialized = false;

  init(): void {
    if (this.initialized || !this.datadog.enabled) {
      return;
    }
    this.initialized = true;

    void Promise.all([this.datadog.init(), import('web-vitals')]).then(([, { onCLS, onINP, onLCP, onTTFB }]) => {
      const reportMetric = (metric: Metric): void => {
        this.datadog.addAction(`web-vital:${metric.name}`, {
          value: metric.value,
          rating: metric.rating,
          delta: metric.delta,
          id: metric.id,
          navigationType: metric.navigationType
        });
      };

      onCLS(reportMetric);
      onINP(reportMetric);
      onLCP(reportMetric);
      onTTFB(reportMetric);
    });
  }
}
